export type CMComposerContext = 'createRequest' | 'queue' | 'flaggedCell';

export const CMComposerContexts: Readonly<Record<string, CMComposerContext>> = {
  createRequest: 'createRequest',
  queue: 'queue',
  flaggedCell: 'flaggedCell',
};
